module.exports = __webpack_public_path__ + "img/model.c1d71bd.svg";